module.exports = __webpack_public_path__ + "img/articles_w.3206a56d.svg";